var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('app-svg',{staticClass:"banner__svg1",style:({ fill: _vm.$store.state.bannerdata.background_color })}),_vm._v(" "),_c('app-svg',{staticClass:"banner__svg2",style:({ fill: _vm.$store.state.bannerdata.background_color })}),_vm._v(" "),_c('p',{staticClass:"banner__p",style:({ color: _vm.$store.state.bannerdata.text_color })},[_vm._v("\n    "+_vm._s(_vm.$store.state.bannerdata.text)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3010828e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/banner.vue
// module id = 496
// module chunks = 0